import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Clipboard } from '@angular/cdk/clipboard';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  BUSINESS_ID_TYPES,
  BUSINESS_TYPES,
  COUNTRIES,
  INDUSTRIES,
  JOB_POSITIONS,
  REGIONS,
} from './static-data';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss'],
})
export class RegistrationComponent implements OnInit {
  @Input() display;
  @Output() closeModal = new EventEmitter();

  items: MenuItem[];

  activePage = 1;
  locate: string;
  isTaxID: string;
  secondary: string;
  sole: string;
  identity = 'direct';

  businessName;
  businessTypes = BUSINESS_TYPES;

  SelectedBusinessType;
  businessIDTypes = BUSINESS_ID_TYPES;
  SelectedBusinessIDType;
  numberFormat = '';
  numberMsg;
  industries = INDUSTRIES;
  SelectedIndustry;
  regions = REGIONS.map((r) => r.value);
  selectedRegion = [];

  addressType = '';
  countries = COUNTRIES;
  SelectedCountry;
  addresses = [
    {
      id: 1,
      country: 'US',
      state: 'NJ',
      city: 'Princeton',
      street1: '2 Research Way',
      street2: '',
      zipcode: '08540',
      sid: 'AD2e1f227f49a953914df85e02131718da',
    },
    {
      id: 2,
      country: 'US',
      state: 'NJ',
      city: 'BORDENTOWN',
      street1: '272 DUNNS MILL RD NUM 30',
      street2: '',
      zipcode: '08505',
      sid: 'ADb7548ae73503b2c30903410a807a642b',
    },
  ];
  selectedAddress;

  countryCode = '+1';
  jobPositions = JOB_POSITIONS;
  anotherAuth = '';
  SelectedJobPosition;
  authCheck = false;
  accurateCheck = false;
  correctCheck = false;

  isEditInfo = false;
  isEditAddress = false;
  isEditAuth = false;

  companyType: string;
  brandType = 'Standard';
  isPolitical: boolean;
  isSubmitBrand = false;
  isConfirm = false;

  service = [
    {
      id: 1,
      name: 'Default Conversations Service',
      sid: 'MG12c42277e4ad7dedabd5820c6e374d5e',
      isActive: false,
    },
    {
      id: 2,
      name: 'New Messaging Service',
      sid: 'MGec0384f93f16b9c4425f54fbd86b70cc',
      isActive: false,
    },
  ];
  filteredService = [];
  selectedService;
  displayMSError = false;
  displayExample = false;
  displayConfirm = false;
  outkeywords = [
    { id: 1, name: 'CANCEL' },
    { id: 1, name: 'END' },
    { id: 1, name: 'QUIT' },
    { id: 1, name: 'UNSUBSCRIBE' },
    { id: 1, name: 'STOP' },
    { id: 1, name: 'STOPALL' },
  ];
  helpkeywords = [
    { id: 1, name: 'HELP' },
    { id: 2, name: 'INFO' },
  ];

  cases = [
    {
      label: 'Campaign Vetting Required',
      value: 'required1',
      items: [
        {
          label: 'Low Volume Mixed',
          value: 'low-volume',
          rate: '($1.50/month)',
          details:
            "The Low Volume Mixed Campaign use case can be used to send messages of multiple use cases such as Customer Care and Delivery Notification, but it is on the lowest throughput tier regardless of the Brand's Trust Score. Due to the lower cost, it is recommended for customers with the Low Volume Standard Brand, as well as Standard Brand customers who do not need high throughput.",
        },
        {
          label: 'Two-Factor authentication (2FA)',
          value: '2fa',
          rate: '($10.00/month)',
          details: 'Any authentication or account verification such as OTP.',
        },
        {
          label: 'Account Notification',
          value: 'account-noti',
          rate: '($10.00/month)',
          details:
            'Notifications about the status of an account or related to being a part of an account.',
        },
        {
          label: 'Customer Care',
          value: 'customer-care',
          rate: '($10.00/month)',
          details:
            'Support, account management, and other avenues of customer interaction.',
        },
        {
          label: 'Delivery Notification',
          value: 'delivery-noti',
          rate: '($10.00/month)',
          details: 'Information about the status of a delivery.',
        },
        {
          label: 'Fraud Alert Messaging',
          value: 'fraud',
          rate: '($10.00/month)',
          details:
            'Messaging about potential fraudulent activity such as spending alerts.',
        },
        {
          label: 'Higher Education',
          value: 'high-edu',
          rate: '($10.00/month)',
          details:
            'Message campaigns from colleges, universities, and other education institutions.',
        },
        {
          label: 'Marketing',
          value: 'marketing',
          rate: '($10.00/month)',
          details: 'Promotional content such as sales and limited time offers.',
        },
        {
          label: 'Mixed',
          value: 'mixed',
          rate: '($10.00/month)',
          details:
            'A campaign that covers multiple use cases such as Customer Care and Delivery Notifications. Note - mixed campaigns are likely to have lower throughput and a higher cost per message.',
        },
        {
          label: 'Polling and voting',
          value: 'poll-voting',
          rate: '($10.00/month)',
          details:
            'For conducting polling and voting, such as customer surveys. Not for political use.',
        },
        {
          label: 'Public Service Announcement',
          value: 'public',
          rate: '($10.00/month)',
          details: 'PSAs to raise audience awareness about a given topic.',
        },
        {
          label: 'Security Alert',
          value: 'serurity',
          rate: '($10.00/month)',
          details:
            'Notification of a compromised system (software or hardware related).',
        },
      ],
    },
    {
      label: 'Campaign Vetting and Carrier Post Approval Required',
      value: 'required2',
      items: [
        {
          label: 'Agents and Franchises',
          value: 'agents-franchises',
          rate: '($30.00/month)',
          details:
            'Brands that have multiple agents, franchises or offices in the same brand vertical, but require individual localized numbers per agent/location/office. Note: Franchises/businesses with a separate EIN should register as a separate brand. Maximum 5000 numbers per Campaign.',
        },
        {
          label: 'Emergency',
          value: 'emergency',
          rate: '($5.00/month)',
          details:
            'Notification services designed to support public safety/health during natural disasters, armed conflicts, pandemics, and other national or regional emergencies.',
        },
        {
          label: 'K-12 Education',
          value: 'k12-edu',
          rate: '($10.00/month)',
          details:
            'For messaging platforms that support schools from grades K-12 and distance learning centers.',
        },
        {
          label: 'Proxy',
          value: 'public',
          rate: '($10.00/month)',
          details:
            "Peer-to-peer app-based group messaging with proxy/pooled numbers. Supporting personalized services and non-exposure of personal numbers for enterprise or A2P communications. A phone number is assigned to a conversation (e.g. end-user/agent pair), rather than to a single business or individual. Both parties to the conversation send text messages to that number, which acts as a relay and protects the privacy of both users' personal numbers.",
        },
        {
          label: 'Social',
          value: 'social',
          rate: '($10.00/month)',
          details:
            'Communication between public figures/influencers and their communities.',
        },
        {
          label: 'Sweepstake',
          value: 'sweepstake',
          rate: '($10.00/month)',
          details: 'All sweepstakes-related messaging.',
        },
      ],
    },
  ];
  selectedCase;
  selectedParentCase;
  selectedCaseValue;
  messagingService = 'new';

  // Form
  customerProfileForm: FormGroup;
  registerBrandForm: FormGroup;
  campaignRegForm: FormGroup;
  assestBaseUrl: string = environment.assestsBasePath;

  constructor(
    private fb: FormBuilder,
    private clipboard: Clipboard,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.initCustomerProfileForm();
    this.loadMenu();
  }

  private initCustomerProfileForm(): void {
    this.customerProfileForm = this.fb.group({
      profileInfo: this.fb.group({
        locate_in_usa: [null],
        has_tax_id: [null],
        secondary_customer: [null],
        sole_proprietor: [null],
      }),
      businessDetails: this.fb.group({
        friendlyName: [''],
        business_name: ['', [Validators.required]],
        business_identity: ['', [Validators.required]],
        business_type: ['', [Validators.required]],
        business_registration_identifier: [''],
        business_registration_number: [''],
        business_industry: ['', [Validators.required]],
        website_url: ['', [Validators.required]],
        business_regions_of_operation: ['', [Validators.required]],
      }),
      businessAddress: this.fb.group({
        addressType: [null],
        customerName: [''],
        friendlyName: [''],
        isoCountry: ['', [Validators.required]],
        street: ['', [Validators.required]],
        streetSecondary: [''],
        city: ['', [Validators.required]],
        region: ['', [Validators.required]],
        postalCode: ['', [Validators.required]],
        autoCorrectAddress: [true],
        emergencyEnabled: [true],
      }),
      notificationSetting: this.fb.group({
        email: ['', [Validators.required, Validators.email]],
      }),
      contactInfo: this.fb.group({
        anotherAuth: [null],
        confirm_contacted_by_twilio: [false, [Validators.required]],
        representativeas: this.fb.array([
          this.fb.group({
            first_name: ['', [Validators.required]],
            last_name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            business_title: ['', [Validators.required]],
            country: ['', [Validators.required]],
            phone_number: ['', [Validators.required]],
            job_position: ['', [Validators.required]],
          }),
        ]),
      }),
      accept_twilio_privacy: [null, [Validators.required]],
    });

    const profileInfo = this.customerProfileForm.get(
      'profileInfo'
    ) as FormGroup;

    profileInfo
      .get('locate_in_usa')
      .valueChanges.pipe(
        tap(() =>
          profileInfo.patchValue({
            has_tax_id: null,
            secondary_customer: null,
            sole_proprietor: null,
          })
        )
      )
      .subscribe();

    profileInfo
      .get('has_tax_id')
      .valueChanges.pipe(
        tap(() =>
          profileInfo.patchValue({
            secondary_customer: null,
            sole_proprietor: null,
          })
        )
      )
      .subscribe();

    profileInfo
      .get('secondary_customer')
      .valueChanges.pipe(
        tap((value) => {
          const businessDetails = this.customerProfileForm.get(
            'businessDetails'
          ) as FormGroup;
          if (value) {
            businessDetails
              .get('business_registration_identifier')
              .addValidators(Validators.required);
            businessDetails
              .get('business_registration_number')
              .addValidators(Validators.required);
          } else {
            businessDetails
              .get('business_registration_identifier')
              .clearValidators();
            businessDetails
              .get('business_registration_number')
              .clearValidators();
          }
        })
      )
      .subscribe();
  }

  get customerBusinessRegionsControl(): FormControl {
    return this.customerProfileForm.get(
      'businessDetails.business_regions_of_operation'
    ) as FormControl;
  }

  // Convenience getter for easy access to form array
  get authRepresentativeArray(): FormArray {
    return this.customerProfileForm.get(
      'contactInfo.representativeas'
    ) as FormArray;
  }

  addAuthRepresentativeFormGroup() {
    if (this.authRepresentativeArray.length > 1) return;
    const newFormGroup = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      business_title: ['', [Validators.required]],
      country: ['', [Validators.required]],
      phone_number: ['', [Validators.required]],
      job_position: ['', [Validators.required]],
    });

    this.authRepresentativeArray.push(newFormGroup);
  }

  removeAuthRepresentativeFormGroup() {
    if (this.authRepresentativeArray.length > 1) {
      this.authRepresentativeArray.removeAt(
        this.authRepresentativeArray.length - 1
      );
    }
  }

  getFormGroup(index: number): FormGroup {
    return this.authRepresentativeArray.at(index) as FormGroup;
  }

  customerFormValue(name: string) {
    return this.customerProfileForm?.get(name)?.value;
  }

  close() {
    this.closeModal.emit();
  }

  loadMenu() {
    this.items = [
      {
        label: 'Create Customer Profile',
        items: [
          {
            label: 'Profile needs',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 2
                ? 'green-icon'
                : this.activePage == 1
                  ? 'active-menu'
                  : '',
            command: () => {
              this.activePage = 1;
            },
          },
          {
            label: 'Business Details',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 3
                ? 'green-icon'
                : this.activePage == 2
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 2,
            command: () => {
              this.activePage = 2;
            },
          },
          {
            label: 'Business Address',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 4
                ? 'green-icon'
                : this.activePage == 3
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 3,
            command: () => {
              this.activePage = 3;
            },
          },
          {
            label: 'Contact Information',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 5
                ? 'green-icon'
                : this.activePage == 4
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 4,
            command: () => {
              this.activePage = 4;
            },
          },
          {
            label: 'Review and Submit',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 6
                ? 'green-icon'
                : this.activePage == 5
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 5,
            command: () => {
              this.activePage = 5;
            },
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: 'Register Brand',
        items: [
          {
            label: 'Submit Brand',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 7
                ? 'green-icon'
                : this.activePage == 6
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 6,
            command: () => {
              this.activePage = 6;
            },
          },
          {
            label: 'View A2P messaging limits/feedback',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 8
                ? 'green-icon'
                : this.activePage == 7
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 7,
            command: () => {
              this.activePage = 7;
            },
          },
        ],
      },
      {
        separator: true,
      },
      {
        label: 'Campaign Registration',
        items: [
          {
            label: 'Register A2P Campaign',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 9
                ? 'green-icon'
                : this.activePage == 8
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 8,
            command: () => {
              this.activePage = 8;
            },
          },
          {
            label: 'Register Phone Numbers',
            icon: 'pi pi-check-circle',
            styleClass:
              this.activePage >= 10
                ? 'green-icon'
                : this.activePage == 9
                  ? 'active-menu'
                  : '',
            disabled: this.activePage < 9,
            command: () => {
              this.activePage = 9;
            },
          },
        ],
      },
    ];
  }
  formatNumbe() {
    const businessRegId = this.customerFormValue(
      'businessDetails.business_registration_identifier'
    );
    if (businessRegId === 'EIN') {
      this.numberFormat = '12-3456789';
      this.numberMsg =
        'Enter the EIN / Tax ID as it appears in the EIN listing.';
    } else if (businessRegId === 'Other') {
      this.numberFormat = '';
      this.numberMsg =
        'Specify what other registry you will use to identify your business.';
    } else {
      this.numberFormat = '123456789';
      this.numberMsg = 'The number used to identify your business.';
    }
  }

  copy(value: HTMLElement): void {
    const text: string = value.textContent || '';
    console.log(text);
    const successful = this.clipboard.copy(text);

    if (successful) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied Successfully.',
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Copied Failed',
      });
    }
  }
  showSelect(ele) {
    console.log(ele);
    for (let s of this.cases) {
      for (let m of s.items) {
        if (ele == m.value) {
          this.selectedParentCase = s;
          this.selectedCase = m;
        }
      }
    }
  }
  filterService(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < this.service.length; i++) {
      let s = this.service[i];
      if (s.sid.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(s);
      }
    }
    this.filteredService = filtered;
  }
  checkService() {
    if (!this.selectedService.isActive) {
      this.displayMSError = true;
      this.selectedService = null;
    }
  }
  successExample() {
    this.displayExample = true;
  }
  confirmRegistration() {
    this.displayConfirm = true;
  }
  confirm() {
    this.displayConfirm = false;
    this.isConfirm = true;
  }

  submitContactInformation() {
    this.activePage = 6;
    this.loadMenu();
    console.log('Customer Information', this.customerProfileForm.value);
  }
}
